import * as React from 'react';
import styles from './icon.module.scss';
import { IconProps } from './IconTypes';
import { GeneratedBrandIcon } from './generated/GeneratedBrandIcon';
import { GeneratedSystemIcon } from './generated/GeneratedSystemIcon';

const IconMap = {
  brand: GeneratedBrandIcon,
  system: GeneratedSystemIcon,
};

export const Icon = ({
  ariaLabel,
  brandColor = 'default',
  color = '$color-primary-a3',
  disabled = false,
  name,
  set = 'system',
  size = 'medium',
  ...rest
}: IconProps) => {
  const baseClassName = styles['bsw-icon'];
  const id = set + '-' + name;
  const isBrandIcon = set === 'brand';
  const sizeClass = styles[`${set}-${size}`];
  let classes = `${baseClassName} ${sizeClass} ${
    disabled ? styles[id + '--disabled'] : styles[id]
  }`;
  let fill = color; // for system icons fill needs to match color

  if (isBrandIcon) {
    if (brandColor === 'inverse') {
      color = '$color-primary-c1';
      fill = '$color-primary-b1';
    } else {
      color = '$color-primary-a3';
      fill = '$color-primary-b1';
    }
  }

  if (disabled) {
    color = '$color-secondary-a3';
    fill = '$color-secondary-a3';
  }

  let _color = styles[`${color.replace('$', '')}`];
  let _fill = isBrandIcon ? styles[`${fill.replace('$', '')}`] : 'currentColor';

  const Component = IconMap[set];

  return (
    <Component
      // @ts-ignore
      aria-hidden={ariaLabel ? false : true}
      aria-label={ariaLabel}
      color={_color}
      className={classes}
      // @ts-ignore
      fill={_fill}
      // @ts-ignore
      icon={name}
      {...rest}
    />
  );
};
